(function($) {
  $.fn.stalkerMenu = function() {
    const containerMenu = $(this),
      menu = $('.stalker-menu'),
      sections = this.find('section'),
      menuElemnt =
        '<div class="stalker-menu"><div class="container"><div class="row"><div class="col-md-12"><ul class="menu-container"></ul></div></div></div></div>',
      menuHeight = 160,
      menuActiveHeight = 80;

    let menuPositionY = 0,
      menuCurrentHeight = menuActiveHeight;

    /* Creating Menu and Buttons */

    if (sections.length != 0) {
      this.prepend(menuElemnt);
      sections.each((index, current) => {
        sections.eq(index).addClass('section-' + index);
        this.find('.menu-container').append(
          '<li class="button-menu button-section-' +
            index +
            '" data-section="section-' +
            index +
            '"><span>' +
            sections.eq(index).attr('data-name') +
            '</span></li>'
        );
      });
    } else {
      console.log("Sections doesn't exist!!");
    }

    /* Setting points of activity  */

    menuPositionY = $('.section-0')[0].offsetTop;

    /* Button functionalities */

    this.find('.button-menu').click(function() {
      const target = '.' + $(this).attr('data-section');
      const targetSection = containerMenu.find(target);
      if (target == '.section-0') {
        menuCurrentHeight = menuHeight;
      } else {
        menuCurrentHeight = menuActiveHeight;
      }
      $('html,body').stop().animate(
        {
          scrollTop: targetSection[0].offsetTop - menuCurrentHeight + 4
        },
        1000
      );
    });

    /* Scroll activities  */

    window.addEventListener('scroll', function(e) {
      const scrollPos = $(document).scrollTop();

      if (
        Math.floor(scrollPos) >= menuPositionY &&
        Math.floor(scrollPos) <= containerMenu[0].offsetHeight + menuPositionY - menuHeight
      ) {
        $('.stalker-menu').addClass('active');
      } else {
        $('.stalker-menu').removeClass('active');
      }

      /* Comparing the section position and the scroll position and adding classes */

      $('.button-menu').each(function() {
        const currLink = $(this);
        const refElement = $('.' + currLink.attr('data-section'));
        if (
          refElement.position().top - menuCurrentHeight <= scrollPos &&
          refElement.position().top + refElement.outerHeight() - menuCurrentHeight > scrollPos
        ) {
          menu.find('.button-menu').removeClass('active');
          currLink.addClass('active');
          refElement.addClass('initialized');
        } else {
          currLink.removeClass('active');
        }
      });
    });

    return this;
  };
})(jQuery);



// WEBPACK FOOTER //
// ./src/pages/media-publishing/plugins/stalkerMenu/index.js